import React from "react";
import { CatalogueOrgManager } from "../../components/catalogue";

/**
 * Catalogue Organization Manager Page
 * 
 * This page provides a comprehensive catalogue management interface for organization managers.
 * Features include:
 * - Catalogue list with search and filtering
 * - Catalogue sharing with customers via WhatsApp/Email
 * - Detailed catalogue management with multiple tabs:
 *   - Basic details and summary
 *   - Product management (CRUD operations)
 *   - Pricing management with global and per-product adjustments
 *   - Performance analytics and dashboard
 *   - Customer inquiries with communication tools
 *   - Security and access settings
 *   - Activity tracking and analytics
 */
const CatalogueManagerPage: React.FC = () => {
  return (
    <div className="catalogue-manager-page">
      <CatalogueOrgManager />
    </div>
  );
};

export default CatalogueManagerPage;
